<template>
  <div>
    <v-alert v-if="error" type="error" dense class="mb-0">
      {{ error }}
    </v-alert>
    <div v-else class="d-flex align-center gap-1">
      <v-select
        v-model="selected"
        :items="items"
        label="Conta bancária"
        :loading="loading"
        outlined
        dense
        return-object
        item-text="bank"
        item-value="id"
        hide-details="auto"
        no-data-text="Nenhuma conta bancária encontrada"
        :rules="rules"
      >
        <template v-slot:selection="{ item }">
          <div class="d-flex align-center gap-2">
            <v-icon small left>mdi-bank</v-icon>
            <span>{{ item.bank }}</span>
            •
            <span class="ml-auto">Pix: {{ item.pixKey }}</span>
          </div>
        </template>
        <template v-slot:item="{ item }">
          <div class="d-flex align-center gap-2">
            <v-icon small left>mdi-bank</v-icon>
            <span>{{ item.bank }}</span>
            •
            <span class="ml-auto">Pix: {{ item.pixKey }}</span>
          </div>
        </template>
      </v-select>
      <v-btn color="primary" icon @click="addBankAccount">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <bank-account-modal
      :organization="organization"
      @success="loadMyBankAccounts"
    />
  </div>
</template>

<script>
import ORGANIZATION from "@/services/admin/organizations";
import BankAccountModal from "@/components/global/BankAccountModal.vue";

export default {
  components: {
    BankAccountModal,
  },
  props: {
    value: {
      type: Object | null,
      required: true,
    },
    organization: {
      type: Object,
      required: true,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      items: [],
      loading: false,
      error: null,
    };
  },
  methods: {
    addBankAccount() {
      this.$root.$emit("add-bank-account");
    },
    async loadMyBankAccounts() {
      try {
        const response = await ORGANIZATION.getBankAccount(
          this.organization.id
        );
        this.items = response.bankAccounts;
      } catch (error) {
        this.error = error.message || "Erro ao carregar contas bancárias";
      }
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async mounted() {
    await this.loadMyBankAccounts();
  },
};
</script>
